import { apiPostRequest } from '../../../../utils/api/post';
import { SignInRequest, SignInResponse } from '../../model/auth';
import { BASE_URL } from '../../../../utils/auth';

export const signInAPI = (data: SignInRequest): Promise<SignInResponse> =>
  apiPostRequest<SignInRequest, SignInResponse>({
    apiUrl: `${BASE_URL}/auth/signin`,
    data,
  });
